import { render } from "./PricePage.vue?vue&type=template&id=61d15c6f&scoped=true"
import script from "./PricePage.vue?vue&type=script&lang=js"
export * from "./PricePage.vue?vue&type=script&lang=js"

import "./PricePage.vue?vue&type=style&index=0&id=61d15c6f&scoped=true&lang=css"

import exportComponent from "/Users/emperinter/app/HTML/watermark-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d15c6f"]])

export default __exports__